import { render, staticRenderFns } from "./DoneAppointmentsSection.vue?vue&type=template&id=a619694a"
import script from "./DoneAppointmentsSection.vue?vue&type=script&lang=js"
export * from "./DoneAppointmentsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports